import { render } from "./reportes_bigquery.vue?vue&type=template&id=0c382a24"
import script from "./reportes_bigquery.vue?vue&type=script&lang=js"
export * from "./reportes_bigquery.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__